<template>
    <div class="result">
        <div class="title_cover mt-5">
            <h3>{{$parent.uniquesso(null)}}</h3>
        </div>
        
        <div class="title_cover mb-10">
            <h3 v-if="data_api.polling.result_type=='text'" v-html="data_api.polling.result_text"></h3>
            <h3 v-else>{{data_api.result.title || 'Hasil Polling!'}}</h3>
        </div>

        <div v-if="items && data_api.polling.result_type=='chart'">
            <transition-group tag="div" name="list">
                <div class="row-polling mb-8" v-for="(p,i) in items" :key="'key-'+i">
                  
                    <div :class="'block_bar ' + (i%2==0?'grey_color':'orange_color')" v-if="data_api.polling.result_row=='all' || i<data_api.polling.result_row ">
                        <div class="block_hidden">
                            <div class="block_progress" :style="'width:'+p.result_percent"></div>
                        </div>
                        <div class="left_info">
                            <div class="thumb_polling" v-if="p.media || p.thumbnail">
                                <img :src="(p.thumbnail || (checkImageUrl(p.media)?p.media:null)) || 'https://via.placeholder.com/150?text='+(i+1)" />
                            </div>
                            <span class="caption_polling">{{ p.item }}</span>
                        </div>
                        <div class="right_info">
                            <span class="percent_polling">{{p.result_percent}}</span>
                        </div>
                    </div>

                </div>
            </transition-group>
        </div>

        <div class="description mt-3" v-html="data_api.result.description"></div>

        <div class="link-row mt-7 mb-5">
          <div class="thumbnail-group mt-6">
            <v-img
              class="ma-auto"
              max-height="auto"
              max-width="100%"
              :src="data_api.result.real"
              :lazy-src="data_api.result.photo"
              crossOrigin="true" 
              >
            </v-img>
          </div>
        </div>
        
        <share :data_api="data_api" :currentUrl="currentUrl" :playAgain="!data_api.is_unique" :shareNav="true" :title="data_api.polling.result_text||none" :description="data_api.result.description||null"/>

    </div>
</template>

<style scoped>

/** animate **/
.list-enter-active,
.list-leave-active,
.list-move {
  transition: 100ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}
</style>

<script>
const Share = () => import(/* webpackChunkName: "share" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackPreload: true */'../Share.vue');
import md5 from 'crypto-js/md5'

export default {
  name: "ResultPolling",
  props:['data_api', 'currentUrl'],
  components: { Share },
  data() {
    return {
      cInterval: null,
      currentUrlResult: this.currentUrl,
      items: null,
    };
  },
  created()
  {
    var th = this

    //set polling
    if( !this.$cookies.get('newshub_submitPolling_'+this.data_api.id) )
    {
      this.$store.dispatch('api_post_ic_polling', function(res){

          var code = th.$store.state.data.post.profiling_answer ? md5(JSON.stringify(th.$store.state.data.post.profiling_answer)).toString() : 1

          th.$cookies.set('newshub_submitPolling_'+res.id, code);

          th.items = res.polling.choose.sort((a,b)=> a.result>b.result?-1:1 );
      })
    }

    th.getPolling();

    th.cInterval = setInterval(()=>{ th.getPolling() },5000)
  },
  beforeDestroy() 
  {
      clearInterval(this.cInterval);
  },
  methods:{
      getPolling()
      {
        var th = this
        
        this.$store.dispatch('api_ic_polling_check', function(res){
            
            th.items = res.polling.choose.sort((a,b)=> a.result>b.result?-1:1 );
        })
      }
  }
}
</script>